"use strict";
/**
 * Created by rouven on 12.04.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var with_tooltip_1 = __importDefault(require("@wikom/with-tooltip"));
/**
 * Renders Symbol Element and sets class names automatically.
 * If symbol contains a tooltip, is will be rendered using withTooltip
 *
 * @param symbol - can be either string or object
 * @param spinning
 * @returns
 */
var Symbol = function (_a) {
    var symbol = _a.symbol, _b = _a.spinning, spinning = _b === void 0 ? false : _b;
    var params = {
        className: "fa fa-fw fa-"
    };
    switch (typeof symbol) {
        case 'object':
            if (symbol.symbol) {
                params.className += symbol.symbol;
            }
            if (symbol.className) {
                params.className += ' ' + symbol.className;
            }
            break;
        case 'string':
            params.className += symbol;
            break;
    }
    if (spinning) {
        params.className += ' fa-spin';
    }
    return (0, with_tooltip_1["default"])(typeof symbol === 'object' ? symbol.tooltip : undefined)(react_1["default"].createElement("i", __assign({}, params)));
};
exports["default"] = Symbol;
